'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: transparent;\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.6em;\n  padding: 8px 16px;\n  color: ', ';\n\n  &::placeholder {\n    color: ', ';\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: ', ';\n    border: ', ';\n    cursor: not-allowed;\n    color: ', ';\n  }\n\n  &:readonly {\n    background-color: ', ';\n    border: ', ';\n    cursor: default;\n    color: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  background: transparent;\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.6em;\n  padding: 8px 16px;\n  color: ', ';\n\n  &::placeholder {\n    color: ', ';\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: ', ';\n    border: ', ';\n    cursor: not-allowed;\n    color: ', ';\n  }\n\n  &:readonly {\n    background-color: ', ';\n    border: ', ';\n    cursor: default;\n    color: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n      border: ', ';\n      border-radius: ', ';\n\n      &:not(:read-only):not(:disabled):hover {\n        border: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):focus {\n        border: ', ';\n      }\n    '], ['\n      background-color: ', ';\n      border: ', ';\n      border-radius: ', ';\n\n      &:not(:read-only):not(:disabled):hover {\n        border: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):focus {\n        border: ', ';\n      }\n    ']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: transparent;\n      border: 0;\n    '], ['\n      background-color: transparent;\n      border: 0;\n    ']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['transition: height 0.2s ease-in-out;'], ['transition: height 0.2s ease-in-out;']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n      overflow: hidden;\n      resize: none;\n    '], ['\n      overflow: hidden;\n      resize: none;\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _component = require('react-pure-render/component');

var _component2 = _interopRequireDefault(_component);

var _dom = require('../../utils/dom');

var _style = require('../../utils/style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Escape any html markup from user input values to ensure correct
 * text measurement
 */

var escapeTags = function escapeTags(str) {
  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br />');
};

var StyledTextarea = /*#__PURE__*/(0, _reactEmotion2.default)('textarea')(_templateObject, function (props) {
  return props.theme.colors.navy700;
}, function (props) {
  return props.theme.colors.grey500;
}, function (props) {
  return props.theme.input.inputDisabledBackground;
}, function (props) {
  return props.theme.input.inputDisabledBorder;
}, function (props) {
  return props.theme.input.inputDisabledColor;
}, function (props) {
  return props.theme.input.inputReadonlyBackground;
}, function (props) {
  return props.theme.input.inputReadonlyBorder;
}, function (props) {
  return props.theme.input.inputReadonlyColor;
}, function (props) {
  return props.textareaTheme === 'default' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.white, props.theme.input.inputDefaultBorder, props.theme.input.inputBorderRadius, props.theme.input.inputHoverBorder, props.theme.input.inputActiveBorder);
}, function (props) {
  return props.textareaTheme === 'transparent' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject3);
}, function (props) {
  return props.animate && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject4);
}, function (props) {
  return props.expand && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject5);
});

/**
 * Render a textarea which can expand vertically
 * - The "autogrow/expand" logic looks horrible but, hey, there’s no better way
 *   in the web to get precise text measurements with linebreaking etc.
 *   - It works by mirroring styles into a dummy div and calculating the height from
 *     the mirror
 *   Current known drawbacks:
 *   - .setup() only gets called once so if styles are updater later the mirror might be
 *     out of sync
 */

var Textarea = function (_PureComponent) {
  (0, _inherits3.default)(Textarea, _PureComponent);

  function Textarea(props) {
    (0, _classCallCheck3.default)(this, Textarea);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props));

    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onKeyUp = _this.onKeyUp.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Textarea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setup();
      this.update();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _dom.removeNode)(this.mirror);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event) {
      if (!!this.props.onReturn && event.which === 13 && event.shiftKey === false) {
        event.preventDefault();
        this.props.onReturn(event);
      }
    }

    /**
     * Key up is hooked to watch for content changes
     * @param {Event} event
     */

  }, {
    key: 'onKeyUp',
    value: function onKeyUp(event) {
      this.update();

      if (this.props.onKeyUp) {
        this.props.onKeyUp(event);
      }
    }

    /**
     * Hook into scroll event to prevent jumping while height is updated
     * to fit content
     * @param {Event} event
     */

  }, {
    key: 'onScroll',
    value: function onScroll(event) {
      if (this.props.expand) {
        event.preventDefault();
        var el = _reactDom2.default.findDOMNode(this);
        // $FlowFixMe
        if (el) el.scrollTop = 0;
      }
    }

    /**
     * Update will calculate heights using input contents taking into account
     * the min number of rows provided via props
     */

  }, {
    key: 'update',
    value: function update() {
      if (this.props.expand) {
        var textarea = _reactDom2.default.findDOMNode(this);
        // $FlowFixMe
        var value = textarea ? textarea.value : null;

        // If the value hasn’t changed we don’t need to do anything
        if (this.__lastUpdatedValue__ === value) {
          return false;
        }

        var mirror = this.mirror;
        var html = '';

        mirror.style.display = 'block';

        for (var i = 0; i < this.props.minRows; i++) {
          html += '<br/>';
        }

        mirror.innerHTML = html;
        var minMirrorHeight = mirror.clientHeight;

        html = escapeTags(String(value));

        for (var _i = 0; _i < this.props.lineBuffer; _i++) {
          html += '<br/>';
        }
        mirror.innerHTML = html; // Ensure we are always a line ahead for smoother expanding

        var mirrorHeight = Math.max(minMirrorHeight, mirror.clientHeight);

        mirror.style.display = 'none';

        if (!this.state || this.state.height !== mirrorHeight) {
          this.setState({ height: mirrorHeight });
        }

        this.__lastUpdatedValue__ = value;
      }
      return true;
    }

    /**
     * Setup will configure the dummy "mirror element" to match the input
     * styles as best as possible
     */

  }, {
    key: 'setup',
    value: function setup() {
      if (this.props.expand) {
        // Create a new mirror if we do not have one
        if (!this.mirror) {
          this.mirror = document.createElement('div');
          // $FlowFixMe
          document.body.appendChild(this.mirror);
        }

        var textarea = _reactDom2.default.findDOMNode(this);
        var mirror = this.mirror;
        var style = window.getComputedStyle(textarea);

        mirror.style.display = 'none';
        mirror.style.wordWrap = 'break-word';
        mirror.style.whiteSpace = 'normal';
        mirror.style.paddingTop = style.getPropertyValue('padding-top');
        mirror.style.paddingBottom = style.getPropertyValue('padding-bottom');
        mirror.style.paddingLeft = style.getPropertyValue('padding-left');
        mirror.style.paddingRight = style.getPropertyValue('padding-right');
        mirror.style.width = style.getPropertyValue('width');
        mirror.style.fontFamily = style.getPropertyValue('font-family');
        mirror.style.fontWeight = style.getPropertyValue('font-weight');
        mirror.style.fontSize = style.getPropertyValue('font-size');
        mirror.style.lineHeight = style.getPropertyValue('line-height');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.state || {},
          _ref$height = _ref.height,
          height = _ref$height === undefined ? undefined : _ref$height;

      var _props = this.props,
          animate = _props.animate,
          style = _props.style,
          className = _props.className,
          theme = _props.theme,
          readonly = _props.readonly,
          disabled = _props.disabled,
          onChange = _props.onChange,
          expand = _props.expand,
          otherProps = (0, _objectWithoutProperties3.default)(_props, ['animate', 'style', 'className', 'theme', 'readonly', 'disabled', 'onChange', 'expand']);


      var filteredProps = (0, _extends3.default)({}, (0, _omit3.default)(otherProps, ['editable', 'lineBuffer', 'minRows', 'onReturn']));

      var styleProps = (0, _style.parseStyleProps)(filteredProps);

      return _react2.default.createElement(StyledTextarea, (0, _extends3.default)({
        animate: animate,
        expand: expand,
        textareaTheme: theme,
        onChange: !readonly && onChange,
        className: className,
        disabled: disabled,
        readOnly: readonly,
        onKeyUp: this.onKeyUp,
        onKeyDown: this.onKeyDown,
        style: (0, _extends3.default)({
          height: height
        }, styleProps.style, style),
        onScroll: this.onScroll
      }, styleProps.props, filteredProps));
    }
  }]);
  return Textarea;
}(_component2.default);

Textarea.defaultProps = {
  minRows: 2,
  lineBuffer: 2,
  animate: true,
  theme: 'default',
  onReturn: null
};
exports.default = Textarea;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/textarea/textarea.js
// module id = 357
// module chunks = 114276838955818